import axios from 'axios'
import { STORAGE_KEYS, RESPONSE_STATUS_CODE } from 'constants/common'
import APP_ROUTER from 'constants/router'

export default class BaseAPI {
  client = null

  token = null

  baseURL = `${process.env.REACT_APP_API_URL}/api/v1/backoffice`

  fleetURL = `${process.env.REACT_APP_FLEET_API_URL}/api/v1`

  notificationURL = `${process.env.REACT_APP_NOTIFICATION_API_URL}/api`

  perLogURL = `${process.env.REACT_APP_PER_LOG_API_URL}/api/v1`

  perURL = `${process.env.REACT_APP_PER_API_URL}/api/v1`

  constructor() {
    const instance = axios.create({
      baseURL: this.baseURL,
      headers: {
        Accept: 'application/json'
      },
      timeout: process.env.REACT_APP_AXIOS_REQUEST_TIMEOUT || 3000,
      autoSetToken: true
    })

    instance.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem(STORAGE_KEYS.accessToken)

        if (token && config.autoSetToken) {
          const updatedConfig = {
            ...config,
            headers: { ...config.headers, Authorization: `Bearer ${token}` }
          }
          return updatedConfig
        }

        return config
      },
      (error) => Promise.reject(error)
    )

    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const accessToken = localStorage.getItem(STORAGE_KEYS.accessToken)
        const originalRequest = error.config

        if (
          error.response?.status === RESPONSE_STATUS_CODE.UNAUTHORIZE &&
          accessToken &&
          !originalRequest._retry
        ) {
          originalRequest._retry = true

          try {
            const refreshPath = `${this.baseURL}/refresh-token`
            const authRefreshConf = {
              headers: {
                RefreshToken: `Bearer ${localStorage.getItem(STORAGE_KEYS.refreshToken)}`
              }
            }
            const res = await axios.post(refreshPath, {}, authRefreshConf)

            const newAccessToken = res?.data?.accessToken

            localStorage.setItem(STORAGE_KEYS.accessToken, newAccessToken)
            instance.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`

            return instance(originalRequest)
          } catch (refreshError) {
            localStorage.clear()
            window.location.href = APP_ROUTER.login
            return Promise.reject(refreshError)
          }
        }

        return Promise.reject(error)
      }
    )

    this.client = instance
  }

  static setAccessToken(token) {
    localStorage.setItem(STORAGE_KEYS.accessToken, token)
  }

  static setRefreshToken = (token) => {
    localStorage.setItem(STORAGE_KEYS.refreshToken, token)
  }
}
